module.exports = __webpack_public_path__ + "static/media/Carusele_12.aacffb4a.png";